export default __webpack_public_path__ + "static/media/ic_mim_40.5d9ba502.svg";